import { isFunction } from "lodash";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts";
import { notificationsFullPagePath } from "@/react/helpers/urlHelpers";
import { useSmOrMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { usePopoverPortalContext } from "@circle-react-uikit/PopoverPortal";
import { Typography } from "@circle-react-uikit/Typography";
import { IconButton } from "../../IconButton";
import { NOTIFICATION_ACTION_MAPPER } from "./List/Item/constants";
import { MarkAsReadButton } from "./MarkAsReadButton";
import { NotificationSettingsButton } from "./NotificationSettingsButton";
import { useNotificationsActions } from "./useHeaderNotificationsApi";

interface HeaderProps {
  onClose?: () => void;
}

export const Header = ({ onClose }: HeaderProps) => {
  const history = useHistory();
  const { currentCommunitySettings } = usePunditUserContext();
  const isFullPageNotificationsEnabled =
    currentCommunitySettings?.notifications_full_page_enabled;
  const {
    mutate: performNotificationAction,
    isLoading: areNotificationsBeingMarkedAsRead,
  } = useNotificationsActions();
  const isSmallScreen = useSmOrMdScreenMediaQuery();
  const { onClose: closePopover } = usePopoverPortalContext();
  return (
    <div className="flex items-center justify-between px-6 pb-2 pt-5">
      <Typography.LabelLg weight="medium">
        {t("header_v3.notifications")}
      </Typography.LabelLg>
      <div className="flex items-center space-x-2">
        <MarkAsReadButton
          areNotificationsBeingMarkedAsRead={areNotificationsBeingMarkedAsRead}
          onClick={() =>
            performNotificationAction({
              action: NOTIFICATION_ACTION_MAPPER.markAllAsRead,
            })
          }
        />
        {isFullPageNotificationsEnabled && !isSmallScreen && (
          <TippyV2
            interactive={false}
            content={t("header_v3.open_in_full_page")}
          >
            <Link to={notificationsFullPagePath()}>
              <IconButton
                name="16-square-arrow-top-right"
                iconSize={20}
                onClick={() => {
                  closePopover?.();
                  history.push(notificationsFullPagePath());
                }}
                ariaLabel={t("header_v3.open_in_full_page")}
                iconClassName="!text-dark"
              />
            </Link>
          </TippyV2>
        )}
        <NotificationSettingsButton />
        {isFunction(onClose) && (
          <TippyV2 interactive={false} content={t("header_v3.close")}>
            <IconButton
              name="16-close"
              ariaLabel={t("header_v3.close")}
              onClick={onClose}
              iconClassName="!text-dark"
            />
          </TippyV2>
        )}
      </div>
    </div>
  );
};
